// src/pages/LoginPage/renderers/LoginForm.jsx
import React from 'react';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';

/**
 * Renderiza o formulário de login
 *
 * @param {object} props
 * @param {object} props.schema - JSON Schema do formulário
 * @param {object} props.uiSchema - UI Schema com configurações de widgets
 * @param {object} props.formData - Dados preenchidos no formulário
 * @param {boolean} props.disabled - Desativa o formulário inteiro
 * @param {boolean} props.disabledButton - Desativa apenas o botão
 * @param {Function} props.onSubmit - Callback para submissão do formulário
 * @param {Function} props.onChange - Callback para alteração do formulário
 */
const LoginForm = ({
  schema,
  uiSchema,
  formData,
  disabled,
  disabledButton,
  onSubmit,
  onChange,
}) => {
  const buttonLabel = disabled
    ? 'Aguarde...'
    : 'Acessar o Formulário';

  return (
    <Form
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      validator={validator}
      onSubmit={onSubmit}
      onChange={onChange}
      disabled={disabled}
    >
      <button
        type="submit"
        className="btn btn-primary"
        disabled={disabled || disabledButton}
      >
        {buttonLabel}
      </button>
    </Form>
  );
};

export default LoginForm;
